export const getZoom = (length: number) => (length === 1 ? 16 : 15);
